export default {
  methods: {
    formatCpfCnpj(valor) {
      if (valor == null || valor === '') {
        return '';
      }

      const limpo = String(valor).replace(/[^A-Za-z0-9]/g, '').toUpperCase();

      if (limpo.length === 11 && /^\d{11}$/.test(limpo)) {
        return limpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      if (limpo.length === 14) {
        return limpo.replace(
          /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,
          '$1.$2.$3/$4-$5',
        );
      }

      return valor;
    },
  },
};
